import {
	GridToolbarColumnsButton,
	GridToolbarContainer,
	GridToolbarDensitySelector,
	GridToolbarExport,
	GridToolbarFilterButton
} from "@mui/x-data-grid-premium";

const CustomToolbar = (props) => {
	const {
		color = 'primary',
		showFilters = true,
		showColumns = true,
		showDensity = true,
		showExport = true,
		filtersSlotProps = null,
		columnsSlotProps = null,
		densitySlotProps = null,
		exportSlotProps = null,
	} = props
	return (
		<GridToolbarContainer>
			{showFilters && (
				<GridToolbarColumnsButton
					color={color}
					{...filtersSlotProps ? filtersSlotProps : {}}
				/>
			)}
			{showColumns && (
				<GridToolbarFilterButton
					color={color}
					{...columnsSlotProps ? columnsSlotProps : {}}
				/>
			)}
			{showDensity && (
				<GridToolbarDensitySelector
					color={color}
					{...densitySlotProps ? densitySlotProps : {}}
				/>
			)}
			{showExport && (
				<GridToolbarExport
					color={color}
					{...exportSlotProps ? exportSlotProps : {}}
				/>
			)}
			{props.children}
		</GridToolbarContainer>
	);
};

export default CustomToolbar